import api from '../api'

export default {

  propertyLeases: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/leases?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  createRelatedData: async () => {
    return api.get('api/leases/create')
  },

  create: async propertyLease => {
    return api.post('api/leases', propertyLease)
  },

  files: async (id,files) => {
    return api.post('api/leases/'+id+'/files',files)
  },

  fileDelete: async (id,fileId) => {
    return api.delete('api/leases/'+id+'/files/'+fileId)
  },

  get: async id => {
    return api.get('api/leases/' + id)
  },

  createComment: async (comment) => {
    return api.post('api/leases/'+comment.property_lease_id+'/comments',comment)
  },

  update: async (id,propertyLease) => {
    return api.put('api/leases/' + id, propertyLease)
  },

  terminate: async (id) => {
    return api.get('api/leases/'+id+'/terminate')
  },

  delete: async id => {
    return api.delete('api/leases/' + id)
  },

  propertyInvoices: async (id,page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/leases/${id}/invoices?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },


  images: async (id,images) => {
    return api.post('api/leases/'+id+'/images',images)
  },

  imageDelete: async (id,imageId) => {
    return api.delete('api/leases/'+id+'/images/'+imageId)
  },


}
